import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-print-recibo-modal',
  templateUrl: './print-recibo-modal.component.html',
  styleUrls: ['./print-recibo-modal.component.scss']
})
export class PrintReciboModalComponent implements OnInit {
  @Input() public selected: any = {};
  @Input() private callback: string;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor() {
  }

  ngOnInit() {
  }

  print() {
    window.print();
  }

  emit() {

    if (this.callback) {
      this.goToCallback.emit(this.callback);
    }
  }

  close() {

    this.emit();
    $('#print-recibo-modal').modal('hide');
  }

  open() {
    $('#print-recibo-modal').modal('show');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/print-recibo-modal/print-recibo-modal.component.ts